<h1 class="mf-popup-title">Preklic deljenja v CRPP</h1>
<div class="m-portlet mf-portlet-gray__gray-background">
    <div class="m-portlet__body">
        <div class="m-content"></div>
        <div class="m-portlet">
            <div class="m-portlet__head">
                <div class="m-portlet__head-caption">
                    <div class="m-portlet__head-title">
                        <h3 class="m-portlet__head-text">Vpišite razlog preklica deljenja listine</h3>
                    </div>
                </div>
            </div>
            <div class="m-portlet__body">
                <div class="m-list-search__result-item">
                    <span class="m--font-boldest pr-2">Razlog:</span>
                    <span class="m-list-search__result-item-text">
                        <input [formControl]="reasonField" type="text" class="form-control m-input" />
                    </span>
                    <div *ngIf="reasonField.invalid && reasonField.touched" class="error">
                        <div *ngIf="reasonField.errors.required" class="m--font-danger">Razlog preklica je obvezen podatek.</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer mf-custom-footer">
    <button (click)="activeModal.close(undefined)" type="button" class="ml-auto btn m-btn--pill btn-warning m-btn m-btn--custom" i18n="@@cancel">
        Prekliči
    </button>
    <button
        [disabled]="!reasonField.valid || (isLoading$ | async)"
        (click)="onCancelClick()"
        type="submit"
        class="mr-auto btn m-btn--pill btn-danger m-btn"
    >
        <ng-container *ngIf="isLoading$ | async; else buttonText">
            <div class="d-flex align-items-center justify-content-center">
                <div class="m-loader m-loader--brand loader-size"></div>
                <span class="pl-2">Nalagam...</span>
            </div>
        </ng-container>
        <ng-template #buttonText><span>Potrdi preklic</span></ng-template>
    </button>
</div>
